import type {
  ConditionConfiguration,
  ConditionFilterDescriptor,
} from "../../../../../api/types/fieldConfigurationTypes.ts";
import type { ConditionField, ReportField } from "../../../../../api/types/svTypes.ts";
import { getValidConditionDescriptors } from "./getValidConditions.ts";

export type ConditionFilter = {
  filter: ConditionFilterDescriptor;
  linked: boolean;
};

export const getMeasureCustomConditions = (measures: ReportField[]) => {
  return measures
    .map((measure) => {
      if (!measure.config.customConditions) return undefined;
      return measure.config.customConditions.filter((cc) => cc.filter.values && cc.filter.values.length > 0);
    })
    .filter((mc): mc is ConditionConfiguration[] => !!mc)
    .flatMap((mc) => mc)
    .map((c) => c.filter);
};

const getMeasureLinkedConditions = (measures: ReportField[], conditions: ConditionField[]) => {
  return getValidConditionDescriptors(
    measures
      .map((measure) => {
        if (!measure.config.linkedConditions) return undefined;
        return measure.config.linkedConditions;
      })
      .filter((mc): mc is string[] => !!mc)
      .flatMap((mc) => mc)
      .map((guid) => {
        const condition = conditions.find((c) => c.config.guid === guid);
        return condition;
      })
      .filter((c): c is ConditionField => !!c),
    true
  );
};

export const getAllFilters = (conditions: ConditionField[], measures: ReportField[]) => {
  let validConditionsWithFilters = getValidConditionDescriptors(conditions, false).map((c) => ({
    filter: c.filter,
    linked: false,
  }));

  const measureCustomConditions = getMeasureCustomConditions(measures).map((c) => ({
    filter: c,
    linked: false,
  }));
  const measureLinkedConditions = getMeasureLinkedConditions(measures, conditions).map((c) => ({
    filter: c.filter,
    linked: true,
  }));

  validConditionsWithFilters = validConditionsWithFilters
    .concat(measureCustomConditions)
    .concat(measureLinkedConditions);

  return validConditionsWithFilters;
};
